'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (rules) {
	return rules.map(function (_ref) {
		var _ref2 = _slicedToArray(_ref, 3),
		    name = _ref2[0],
		    token = _ref2[1],
		    info = _ref2[2];

		var str = _types2.default[info.type](name, token, info.options);
		return info.public ? 'public ' + str : str;
	});
};


//////////////////
// WEBPACK FOOTER
// ./~/jspeech/lib/stringify/rules.js
// module id = 240
// module chunks = 0